<template>
   <app-parser_wrapper  :init="init">    </app-parser_wrapper>
</template>

<script>
 export default {

     data () {
       return {
   init: {
     menu:{

       items: [
       {
         title:"Глобальный поиск",
         isSelected: true,
         objName: 'pages',
         dataType:"pages",
         form: [
         {
           type:'select',
           name: 'Сортировка',
           options: [{text:'По умолчанию',value:''},{text:'По дате регистрации',value:'1'},{text:'По популярности',value:'2'}],
           vModel: {name:'sort',value:''},
           vkapi: true
         },
         {
           type:'select',
           name: 'Пол',
           options: [{text:'Любой',value:'0'},{text:'Мужской',value:'2'},{text:'Женский',value:'1'}],
           vModel: {name:'sex',value:'0'},
           vkapi: true
         },
         {
           type:'select-country',
           name: 'Выберите страну',
           cityName: 'Введите название города',
           options: [{text:'Любая',value:''},{text:'Россия',value:'1'},{text:'Украина',value:'2'},{text:'Белорусь',value:'3'},{text:'Казахстан',value:'4'},{text:'Азербайджан',value:'5'}],
           vModel: {name:'country',value:''},
           vModelCitiesIds:{name:'city',value: [] },
           vkapi: true
         },

         {
           type: 'input',
           name: 'Возраст от',
           vModel: {name:'age_from',value:''},
           vkapi: true
         },
         {
           type: 'input',
           name: 'Возраст до',
           vModel: {name:'age_to',value:''},
           vkapi: true
         },
         {
           type: 'input',
           name: 'день рождения',
           vModel: {name:'birth_day',value:''},
           vkapi: true
         },
         {
           type: 'input',
           name: 'месяц рождения',
           vModel: {name:'birth_month',value:''},
           vkapi: true
         },
         {
           type: 'input',
           name: 'год рождения',
           vModel: {name:'birth_year',value:''},
           vkapi: true
         },
         {
           type:'select',
           name: 'Семейное положение',
           options: [{text:'По умолчанию',value:'0'},{text:'Не женат (не замужем)',value:'1'},{text:'Встречается',value:'3'},{text:'Помолвлен(а)',value:'4'},{text:'Женат (замужем)',value:'5'},{text:'Все сложно',value:'6'},{text:'В активном поиске',value:'7'},{text:'Влюблен(а)',value:'8'},{text:'В гражданском браке',value:'9'}  ],
           vModel: {name:'status',value:'0'},
           vkapi: true
         },
         {
           type: 'input',
           name: 'Родной город',
           vModel: {name:'hometown',value:''},
           vkapi: true
         },
         {
           type: 'input',
           name: 'Работа',
           vModel: {name:'company',value:''},
           vkapi: true
         },
         {
           type: 'input',
           name: 'Должность',
           vModel: {name:'position',value:''},
           vkapi: true
         },
         {
           type: 'checkbox',
           name: 'Только онлайн',
           vModel: {name:'online',value:0},
           vkapi: true
         },
         {
           type: 'checkbox',
           name: 'Только с фото',
           vModel: {name:'has_photo',value:0},
           vkapi: true
         },
         {
           type: 'input',
           name: 'Колличество с фразы',
           vModel: {name:'count',value:'1000'},
           vkapi: true
         },
         ],


       },
              ],
     },

    title:{
      first: 'Страниц найдено:'
    },

    searchLoop:{
      active:true,
      placeholder:'Имя Фамилия'
    },

    beforeSearch:{
      title: 'Тут будет отображен результат поиска страниц ',
      activator: false,
      activatorName: 'Начать поиск'
    },


    network:{
      processName: 'pages_global_search',
      dataType: 'pages',
      actionsFile:  'http://'+this.$store.state.localhost+'/'+this.$store.state.path+'/parser/searcher/pages_global_search.php'
    },





    contentMenegment: {
      marginTop: '0px',
      items: {
        selector: {active:true},
        copy: {active:true},
        export: {active:true},
        update: {active:false},
        delete: {active:false},
        autoExport: {active:false}
      },
      contentInfo: {
        type: 'pages',
      },
      autoExport: {
        isActive: false,
        tasksList:[],
      }
     },
     progressСircular: true,
   }


       }
     }
   }
</script>


<style>

</style>
